import { render, staticRenderFns } from "./BackNavigateBtn.vue?vue&type=template&id=2c8a4568"
import script from "./BackNavigateBtn.vue?vue&type=script&lang=js"
export * from "./BackNavigateBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports